import type { EventRequest, ResultKind } from '../domain/contract';
import { api } from './api';
import { hasAnalyticsConsent } from './consent';
import { currentJourney } from './journey';

const SESSION_KEY = 'fh.analytics-session';

/** A random per-tab id, unrelated to the journey or submission, so telemetry cannot be joined to a person. */
function analyticsSession(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(36).padStart(2, '0'))
      .join('')
      .slice(0, 24);
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return 'nostorage0000000';
  }
}

/** Sends nothing unless the visitor has accepted analytics cookies. Never includes contact details. */
export function track(event: EventRequest['event'], detail: { step?: EventRequest['step']; result?: ResultKind } = {}): void {
  if (!hasAnalyticsConsent()) return;
  const { attribution } = currentJourney();
  api
    .event({
      event,
      step: detail.step ?? null,
      result: detail.result ?? null,
      sessionId: analyticsSession(),
      utmSource: attribution.utmSource?.slice(0, 100) ?? null,
      utmMedium: attribution.utmMedium?.slice(0, 100) ?? null,
      utmCampaign: attribution.utmCampaign?.slice(0, 100) ?? null,
      landingVariant: attribution.landingVariant?.slice(0, 100) ?? null,
    })
    .catch(() => undefined);
}
